import React from 'react';
import { LoopButton, Modal, Typography } from '@loophealth/loop-ui-web-library';
import WithThemeProvider from '../../../../theme/WithThemeProvider';
import { IWarningModal } from './types';
import {
    StyledButtonContainer,
    StyledDetailsContainer,
    StyledIconContainer,
    StyledModalContainer,
    StyledWarningModalContent
} from './styles';
import { InfoIcon } from '../../../../assets/img/CustomIcons';
import theme from '../../../../theme';

const WarningModal: React.FC<IWarningModal> = ({ isVisible, setIsVisible, onConfirm, enrolmentDueDate }) => {
    return (
        <Modal isVisible={isVisible} setIsVisible={setIsVisible} disablePadding>
            <WithThemeProvider>
                <StyledModalContainer>
                    <StyledIconContainer>
                        <InfoIcon width="42" height="42" strokeColor={theme.colors.white} />
                    </StyledIconContainer>
                    <StyledDetailsContainer>
                        <Typography variant="large" weight="semiBold">
                            You’re about to edit your selections
                        </Typography>
                        <Typography variant="small">
                            Earlier data and choices are retained. Complete all steps till summary to save securely.
                        </Typography>
                    </StyledDetailsContainer>
                    <StyledWarningModalContent>
                        <div>
                            <InfoIcon width="20" height="20" strokeColor={theme.colors.beyondGrey} />
                        </div>
                        <Typography variant="small">
                            Be sure to finish by&nbsp;
                            <Typography variant="small" weight="semiBold">
                                {enrolmentDueDate}
                            </Typography>
                            , or earlier selections will be used.
                        </Typography>
                    </StyledWarningModalContent>
                    <StyledButtonContainer>
                        <LoopButton variant="filled" onClick={onConfirm}>
                            Start Edit Registration
                        </LoopButton>
                        <LoopButton variant="outline" onClick={() => setIsVisible(false)}>
                            Never mind
                        </LoopButton>
                    </StyledButtonContainer>
                </StyledModalContainer>
            </WithThemeProvider>
        </Modal>
    );
};

export default WarningModal;
